import useProtoMethod from "./useProtoMethod";
import {
  GetMemberDetailsRequest,
  GetMemberDetailsResponse,
  UpdateMembersFamilyRequest,
  UpdateMembersFamilyResponse,
  GetBillingPortalUrlRequest,
  GetBillingPortalUrlResponse,
  GetAdvisorProfileResponse,
  GetAdvisorProfileRequest,
  SubmitReferralResponse,
  SubmitReferralRequest,
  SubmitReactivationRequest,
  SubmitReactivationResponse,
  UpdateMemberNotificationsResponse,
  UpdateMemberNotificationsRequest,
  UpdateMemberProfileRequest,
  UpdateMemberProfileResponse,
  DeleteScheduledActionRequest,
  DeleteScheduledActionResponse,
  ListDigitalSubscriptionProductsRequest,
  ListDigitalSubscriptionProductsResponse,
  UpgradeDigitalSubscriptionRequest,
  UpgradeDigitalSubscriptionResponse,
  NotifySupportUpgradeRequestRequest,
  NotifySupportUpgradeRequestResponse,
} from "protogen/member_service_pb";

import {
  UpdateFamilyRequest,
  UpdateFamilyResponse,
} from "protogen/advisors_service_pb";

const useGetMemberDetails = (
  callback?: (r: GetMemberDetailsResponse) => void,
) => {
  return useProtoMethod<GetMemberDetailsRequest, GetMemberDetailsResponse>(
    "GetMemberDetails",
    GetMemberDetailsResponse,
    { callback },
  );
};

const useUpdateMembersFamily = (
  callback?: (r: UpdateMembersFamilyResponse) => void,
) => {
  return useProtoMethod<
    UpdateMembersFamilyRequest,
    UpdateMembersFamilyResponse
  >("UpdateMembersFamily", UpdateMembersFamilyResponse, { callback });
};

const useGetBillingPortalUrl = (
  callback?: (r: GetBillingPortalUrlResponse) => void,
) => {
  return useProtoMethod<
    GetBillingPortalUrlRequest,
    GetBillingPortalUrlResponse
  >("GetBillingPortalUrl", GetBillingPortalUrlResponse, { callback });
};

const useGetAdvisorProfile = (
  callback?: (r: GetAdvisorProfileResponse) => void,
) => {
  return useProtoMethod<GetAdvisorProfileRequest, GetAdvisorProfileResponse>(
    "GetAdvisorProfile",
    GetAdvisorProfileResponse,
    { callback },
  );
};

const useSubmitReferral = (callback?: (r: SubmitReferralResponse) => void) => {
  return useProtoMethod<SubmitReferralRequest, SubmitReferralResponse>(
    "SubmitReferral",
    SubmitReferralResponse,
    { callback },
  );
};

const useUpdateMemberNotifications = (
  callback?: (r: UpdateMemberNotificationsResponse) => void,
) => {
  return useProtoMethod<
    UpdateMemberNotificationsRequest,
    UpdateMemberNotificationsResponse
  >("UpdateMemberNotifications", UpdateMemberNotificationsResponse, {
    callback,
  });
};

const useUpdateMemberProfile = (
  callback?: (r: UpdateMemberProfileResponse) => void,
) => {
  return useProtoMethod<
    UpdateMemberProfileRequest,
    UpdateMemberProfileResponse
  >("UpdateMemberProfile", UpdateMemberProfileResponse, {
    callback,
  });
};

const useUpdateFamily = (callback?: (r: UpdateFamilyResponse) => void) => {
  return useProtoMethod<UpdateFamilyRequest, UpdateFamilyResponse>(
    "UpdateMemberFamily",
    UpdateFamilyResponse,
    { callback },
  );
};

const useDeleteScheduledAction = (
  callback?: (r: DeleteScheduledActionResponse) => void,
) => {
  return useProtoMethod<
    DeleteScheduledActionRequest,
    DeleteScheduledActionResponse
  >("DeleteScheduledAction", DeleteScheduledActionResponse, { callback });
};

const useSubmitReactivation = (
  callback?: (r: SubmitReactivationResponse) => void,
) => {
  return useProtoMethod<SubmitReactivationRequest, SubmitReactivationResponse>(
    "SubmitReactivation",
    SubmitReactivationResponse,
    { callback },
  );
};

const useListDigitalSubscriptionProducts = (
  callback?: (r: ListDigitalSubscriptionProductsResponse) => void,
) => {
  return useProtoMethod<
    ListDigitalSubscriptionProductsRequest,
    ListDigitalSubscriptionProductsResponse
  >(
    "ListDigitalSubscriptionProducts",
    ListDigitalSubscriptionProductsResponse,
    { callback },
  );
};

const useUpgradeDigitalSubscription = (
  callback?: (r: UpgradeDigitalSubscriptionResponse) => void,
) => {
  return useProtoMethod<
    UpgradeDigitalSubscriptionRequest,
    UpgradeDigitalSubscriptionResponse
  >("UpgradeDigitalSubscription", UpgradeDigitalSubscriptionResponse, {
    callback,
  });
};

const useNotifySupportUpgradeRequest = (
  callback?: (r: NotifySupportUpgradeRequestResponse) => void,
) => {
  return useProtoMethod<
    NotifySupportUpgradeRequestRequest,
    NotifySupportUpgradeRequestResponse
  >("NotifySupportUpgradeRequest", NotifySupportUpgradeRequestResponse, {
    callback,
  });
};

export {
  useGetMemberDetails,
  useUpdateMembersFamily,
  useGetBillingPortalUrl,
  useGetAdvisorProfile,
  useSubmitReferral,
  useSubmitReactivation,
  useUpdateMemberNotifications,
  useUpdateMemberProfile,
  useUpdateFamily,
  useDeleteScheduledAction,
  useListDigitalSubscriptionProducts,
  useUpgradeDigitalSubscription,
  useNotifySupportUpgradeRequest,
};
